



















































































import {
  ComponentInternalInstance,
  computed,
  defineComponent,
  getCurrentInstance,
  provide,
  Ref,
  ref,
  reactive,
  watch,
} from '@vue/composition-api';
import {
  SettingIcon,
  SwapIcon,
  MailIcon,
  ServerIcon,
  InfoCircleIcon,
  CheckCircleFilledIcon,
  CloseCircleFilledIcon,
  SecuredIcon,
  DownloadIcon,
  InternetIcon,
  UploadIcon,
  CloseIcon,
  Icon,
  UserCircleIcon,
} from 'tdesign-icons-vue';
import SystemSetting from '@/renderer/components/dialog/setting/components/SystemSetting.vue';
import NotificationSetting from '@/renderer/components/dialog/setting/components/NotificationSetting.vue';
import SecuritySetting from '@/renderer/components/dialog/setting/components/SecuritySetting.vue';
import ProxySetting from '@/renderer/components/dialog/setting/components/ProxySetting.vue';
import InternalServerSetting from '@/renderer/components/dialog/setting/components/InternalServerSetting.vue';
import LanguageSetting from '@/renderer/components/dialog/setting/components/LanguageSetting.vue';
import UserCenterSetting from '@/renderer/components/user/components/userConfig/UserCenterSetting.vue';
import UploadSetting from '@/renderer/components/dialog/setting/components/UploadSetting.vue';
import DownloadSetting from '@/renderer/components/dialog/setting/components/DownloadSetting.vue';
import { useToggleTabs } from '@/renderer/components/dialog/setting/composition/useToggleTabs';
import smh from '@/renderer/scripts/smh';
import ipc, { IpcEvents } from '@/renderer/scripts/utils/ipc';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { openDevTools } from '@/renderer/scripts/utils/tools';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import store from '@/renderer/store';
import i18n, { i18n_t } from '@/locales/i18n';
import { SettingTab } from '@/renderer/components/dialog/setting/SettingConst';
import { coSync } from '@/renderer/scripts/CoSync/coSync';

export default defineComponent({
  components: {
    UploadSetting,
    DownloadSetting,
    SettingIcon,
    UserCircleIcon,
    CloseIcon,
    DownloadIcon,
    UploadIcon,
    InternetIcon,
    SwapIcon,
    MailIcon,
    ServerIcon,
    InfoCircleIcon,
    CheckCircleFilledIcon,
    CloseCircleFilledIcon,
    ProxySetting,
    NotificationSetting,
    SystemSetting,
    UserCenterSetting,
    SecuredIcon,
    SecuritySetting,
    InternalServerSetting,
    LanguageSetting,
    Icon,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    settingInfo: {
      required: false,
      type: Object,
      default: () => ({ defaultPage: SettingTab.SYSTEM.valueOf() }),
    },
  },
  setup(props, context) {
    // 当前组件
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;

    const innerShow: Ref<boolean> = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const tapValue: Ref<string> = ref(props.settingInfo.defaultPage || SettingTab.SYSTEM.valueOf());
    const securityInfo = reactive({
      enableFileHistory: false,
      haveBackup: false,
    });
    const settingTitleMap = new Map([
      [SettingTab.USER_CENTER, i18n_t('个人设置')],
      [SettingTab.SYSTEM, i18n_t('系统设置')],
      [SettingTab.UPLOAD, i18n_t('上传设置')],
      [SettingTab.DOWNLOAD, i18n_t('下载设置')],
      [SettingTab.SECURITY, i18n_t('安全设置')],
      [SettingTab.PROXY, i18n_t('代理设置')],
      [SettingTab.NOTIFICATIONS, i18n_t('消息设置')],
      [SettingTab.INTERNAL_SERVER, i18n_t('私有化设置')],
      [SettingTab.LANGUAGE, i18n_t('语言设置')],
    ]);

    const _componentsInterceptor = async (val: string) => {
      const oldValue = tapValue.value;
      const $component: any = vm.$refs[oldValue];
      // 返回离开前校验方法
      return await useToggleTabs(val, $component);
    };
    const showPanel = computed(() => {
      return !store.getters.isMobile && !store.getters.isBrowser;
    });
    const methods = {
      async handleClose() {
        const res = await _componentsInterceptor('close');
        if (res === 'close') innerShow.value = false;
      },
      openProtocol(e: any) {
        e.preventDefault();
        dispatchRouter(CONSTANT_URL.serviceAgreement);
      },
      openLocalLog(e: any) {
        e.preventDefault();
        ipc.send(IpcEvents.ON_OPERATE_MAIN_LISTENER, {
          event: 'openLogDataPath',
        });
      },
      /**
       * 要前往的tab标签页，若为close 则代表要关闭dialog
       * @param val
       */
      saveAndChangeTabs(val: string) {
        if (val === 'close') {
          innerShow.value = false;
          return;
        }
        if (val) {
          tapValue.value = val;
        }
      },
      // 修改tab标签页
      async changeTabs(val: string) {
        const res = await _componentsInterceptor(val);
        if (res === val) tapValue.value = val;
      },
      async initSecurityInfo() {
        try {
          coSync
            .center()
            .haveSyncTask()
            .then(ret => {
              if (ret) {
                securityInfo.haveBackup = true;
              } else {
                securityInfo.haveBackup = false;
              }
            });
          const res = await smh.userAPI.getLibraryHistoryExtension();
          const { enableFileHistory } = res.data;
          securityInfo.enableFileHistory = enableFileHistory;
        } catch (e) {
          logger.ui.error('initSecurityInfo error', e);
        }
      },
      openEgg(e: MouseEvent) {
        if (tapValue.value === SettingTab.SYSTEM) {
          openDevTools(e);
        }
      },
    };
    watch(innerShow, async () => {
      if (innerShow.value) {
        reporter.report('setting', {});
        const { isLogined, isPrivate } = vm.$store.getters;
        if (!isPrivate && showPanel && isLogined) {
          vm.$store.dispatch('getUserSetting');
          methods.initSecurityInfo();
        }
        tapValue.value = props.settingInfo.defaultPage || SettingTab.SYSTEM;
      }
    });
    provide('saveAndChangeTabs', methods.saveAndChangeTabs);
    return {
      innerShow,
      tapValue,
      showPanel,
      ...methods,
      securityInfo,
      SettingTab,
      settingTitleMap,
    };
  },
});
